module.exports = __webpack_public_path__ + "img/mowdirect.00df9766.png";